(() => {
  // ISO 3166-1 alpha-2 country code → ISO 4217 currency code.
  // Used when Shopify's localization API returns the store currency (THB)
  // instead of the visitor's country currency — which happens when
  // Shopify Payments isn't available, so Markets doesn't surface alt currencies.
  const COUNTRY_TO_CURRENCY = {
    AD: "EUR",
    AE: "AED",
    AF: "AFN",
    AG: "XCD",
    AI: "XCD",
    AL: "ALL",
    AM: "AMD",
    AO: "AOA",
    AR: "ARS",
    AS: "USD",
    AT: "EUR",
    AU: "AUD",
    AW: "AWG",
    AX: "EUR",
    AZ: "AZN",
    BA: "BAM",
    BB: "BBD",
    BD: "BDT",
    BE: "EUR",
    BF: "XOF",
    BG: "BGN",
    BH: "BHD",
    BI: "BIF",
    BJ: "XOF",
    BL: "EUR",
    BM: "BMD",
    BN: "BND",
    BO: "BOB",
    BQ: "USD",
    BR: "BRL",
    BS: "BSD",
    BT: "BTN",
    BV: "NOK",
    BW: "BWP",
    BY: "BYN",
    BZ: "BZD",
    CA: "CAD",
    CC: "AUD",
    CD: "CDF",
    CF: "XAF",
    CG: "XAF",
    CH: "CHF",
    CI: "XOF",
    CK: "NZD",
    CL: "CLP",
    CM: "XAF",
    CN: "CNY",
    CO: "COP",
    CR: "CRC",
    CU: "CUP",
    CV: "CVE",
    CW: "ANG",
    CX: "AUD",
    CY: "EUR",
    CZ: "CZK",
    DE: "EUR",
    DJ: "DJF",
    DK: "DKK",
    DM: "XCD",
    DO: "DOP",
    DZ: "DZD",
    EC: "USD",
    EE: "EUR",
    EG: "EGP",
    EH: "MAD",
    ER: "ERN",
    ES: "EUR",
    ET: "ETB",
    FI: "EUR",
    FJ: "FJD",
    FK: "FKP",
    FM: "USD",
    FO: "DKK",
    FR: "EUR",
    GA: "XAF",
    GB: "GBP",
    GD: "XCD",
    GE: "GEL",
    GF: "EUR",
    GG: "GBP",
    GH: "GHS",
    GI: "GIP",
    GL: "DKK",
    GM: "GMD",
    GN: "GNF",
    GP: "EUR",
    GQ: "XAF",
    GR: "EUR",
    GT: "GTQ",
    GU: "USD",
    GW: "XOF",
    GY: "GYD",
    HK: "HKD",
    HN: "HNL",
    HR: "EUR",
    HT: "HTG",
    HU: "HUF",
    ID: "IDR",
    IE: "EUR",
    IL: "ILS",
    IM: "GBP",
    IN: "INR",
    IO: "USD",
    IQ: "IQD",
    IR: "IRR",
    IS: "ISK",
    IT: "EUR",
    JE: "GBP",
    JM: "JMD",
    JO: "JOD",
    JP: "JPY",
    KE: "KES",
    KG: "KGS",
    KH: "KHR",
    KI: "AUD",
    KM: "KMF",
    KN: "XCD",
    KR: "KRW",
    KW: "KWD",
    KY: "KYD",
    KZ: "KZT",
    LA: "LAK",
    LB: "LBP",
    LC: "XCD",
    LI: "CHF",
    LK: "LKR",
    LR: "LRD",
    LS: "LSL",
    LT: "EUR",
    LU: "EUR",
    LV: "EUR",
    LY: "LYD",
    MA: "MAD",
    MC: "EUR",
    MD: "MDL",
    ME: "EUR",
    MF: "EUR",
    MG: "MGA",
    MH: "USD",
    MK: "MKD",
    ML: "XOF",
    MM: "MMK",
    MN: "MNT",
    MO: "MOP",
    MP: "USD",
    MQ: "EUR",
    MR: "MRU",
    MS: "XCD",
    MT: "EUR",
    MU: "MUR",
    MV: "MVR",
    MW: "MWK",
    MX: "MXN",
    MY: "MYR",
    MZ: "MZN",
    NA: "NAD",
    NC: "XPF",
    NE: "XOF",
    NF: "AUD",
    NG: "NGN",
    NI: "NIO",
    NL: "EUR",
    NO: "NOK",
    NP: "NPR",
    NR: "AUD",
    NU: "NZD",
    NZ: "NZD",
    OM: "OMR",
    PA: "PAB",
    PE: "PEN",
    PF: "XPF",
    PG: "PGK",
    PH: "PHP",
    PK: "PKR",
    PL: "PLN",
    PM: "EUR",
    PN: "NZD",
    PR: "USD",
    PS: "ILS",
    PT: "EUR",
    PW: "USD",
    PY: "PYG",
    QA: "QAR",
    RE: "EUR",
    RO: "RON",
    RS: "RSD",
    RU: "RUB",
    RW: "RWF",
    SA: "SAR",
    SB: "SBD",
    SC: "SCR",
    SD: "SDG",
    SE: "SEK",
    SG: "SGD",
    SH: "SHP",
    SI: "EUR",
    SJ: "NOK",
    SK: "EUR",
    SL: "SLE",
    SM: "EUR",
    SN: "XOF",
    SO: "SOS",
    SR: "SRD",
    SS: "SSP",
    ST: "STN",
    SV: "USD",
    SX: "ANG",
    SY: "SYP",
    SZ: "SZL",
    TC: "USD",
    TD: "XAF",
    TF: "EUR",
    TG: "XOF",
    TH: "THB",
    TJ: "TJS",
    TK: "NZD",
    TL: "USD",
    TM: "TMT",
    TN: "TND",
    TO: "TOP",
    TR: "TRY",
    TT: "TTD",
    TV: "AUD",
    TW: "TWD",
    TZ: "TZS",
    UA: "UAH",
    UG: "UGX",
    UM: "USD",
    US: "USD",
    UY: "UYU",
    UZ: "UZS",
    VA: "EUR",
    VC: "XCD",
    VE: "VES",
    VG: "USD",
    VI: "USD",
    VN: "VND",
    VU: "VUV",
    WF: "XPF",
    WS: "WST",
    XK: "EUR",
    YE: "YER",
    YT: "EUR",
    ZA: "ZAR",
    ZM: "ZMW",
    ZW: "ZWG",
  };

  // The currency picker (snippets/country-dropdown.liquid) needs the
  // COUNTRY_TO_CURRENCY map because Shopify Markets pins every country's
  // reported currency to the store currency when Shopify Payments isn't
  // enabled — so the Liquid-rendered rows would all read "THB" without this
  // fixup. For each picker we rewrite the option labels and hide options
  // whose currency duplicates another, then refresh the closed-state
  // button. When several countries share a currency, the selected option
  // (aria-selected) wins; otherwise the first option.
  function rewritePicker(dropdown) {
    const keeper = new Map();
    dropdown
      .querySelectorAll('[role="option"][data-option-value]')
      .forEach((option) => {
        const countryCode = (option.dataset.optionValue || "").toUpperCase();
        const mapped = COUNTRY_TO_CURRENCY[countryCode];
        if (!mapped) return;
        const label = option.querySelector(".custom-dropdown__option-label");
        if (label) label.textContent = mapped;
        const kept = keeper.get(mapped);
        if (!kept) {
          keeper.set(mapped, option);
        } else if (option.getAttribute("aria-selected") === "true") {
          kept.hidden = true;
          keeper.set(mapped, option);
        } else {
          option.hidden = true;
        }
      });

    const currentCountry = (window.xcCountryCode || "").toUpperCase();
    const currentCurrency = COUNTRY_TO_CURRENCY[currentCountry];
    if (currentCurrency) {
      const span = dropdown.querySelector("[data-selected-text]");
      if (span) span.textContent = currentCurrency;
    }
  }
  function rewriteAllPickers() {
    document
      .querySelectorAll("simple-dropdown[data-currency-only]")
      .forEach(rewritePicker);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rewriteAllPickers);
  } else {
    rewriteAllPickers();
  }

  const shopifyCurrency = (window.xcDisplayCurrency || "").toUpperCase();
  const country = (window.xcCountryCode || "").toUpperCase();
  const TARGET =
    shopifyCurrency && shopifyCurrency !== "THB"
      ? shopifyCurrency
      : COUNTRY_TO_CURRENCY[country] || "";

  if (!TARGET || TARGET === "THB") return;

  const CACHE_KEY = "xc:fx:thb:v1";
  const TTL_MS = 6 * 60 * 60 * 1000;
  const PRIMARY =
    "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/thb.json";
  const FALLBACK = "https://api.frankfurter.app/latest?from=THB";

  const readCache = () => {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY));
    } catch {
      return null;
    }
  };
  const writeCache = (rates) => {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ ts: Date.now(), rates }),
      );
    } catch {}
  };
  const fresh = (c) => c && Date.now() - c.ts < TTL_MS;

  async function fetchWithTimeout(url, ms = 5000) {
    const ctrl = new AbortController();
    const tid = setTimeout(() => ctrl.abort(), ms);
    try {
      return await fetch(url, { signal: ctrl.signal });
    } finally {
      clearTimeout(tid);
    }
  }

  async function fetchPrimary() {
    const r = await fetchWithTimeout(PRIMARY);
    if (!r.ok) throw new Error("primary");
    const j = await r.json();
    const out = {};
    for (const [k, v] of Object.entries(j.thb || {})) out[k.toUpperCase()] = v;
    return out;
  }

  async function fetchFallback() {
    const r = await fetchWithTimeout(FALLBACK);
    if (!r.ok) throw new Error("fallback");
    const j = await r.json();
    return j.rates || {};
  }

  async function getRates() {
    const cached = readCache();
    if (fresh(cached)) return cached.rates;
    try {
      const r = await fetchPrimary();
      writeCache(r);
      return r;
    } catch {
      try {
        const r = await fetchFallback();
        writeCache(r);
        return r;
      } catch {
        return cached?.rates ?? null;
      }
    }
  }

  const fmt = (amt, code) => {
    try {
      const num = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(amt);
      return `${num} ${code}`;
    } catch {
      return `${Math.round(amt)} ${code}`;
    }
  };

  function annotate(node, rate) {
    if (node.dataset.xcDone) return;
    const cents = parseInt(node.dataset.moneyAmount, 10);
    if (!Number.isFinite(cents)) return;
    const converted = (cents / 100) * rate;
    if (Math.round(converted) === 0) return;
    const maxCents = parseInt(node.dataset.moneyAmountMax, 10);
    const hasRange = Number.isFinite(maxCents) && maxCents !== cents;
    const convertedMax = hasRange ? (maxCents / 100) * rate : null;
    node.dataset.xcDone = "1";
    const span = document.createElement("span");
    span.className = "xc-converted-price";
    span.setAttribute("aria-label", "Approximate. Charged in THB.");
    span.textContent = hasRange
      ? ` (~${fmt(converted, TARGET)} – ${fmt(convertedMax, TARGET)})`
      : ` (~${fmt(converted, TARGET)})`;
    node.after(span);
  }

  async function run() {
    const rates = await getRates();
    const rate = rates?.[TARGET];
    if (!rate) return;
    document
      .querySelectorAll("[data-money-amount]")
      .forEach((n) => annotate(n, rate));
    new MutationObserver((muts) => {
      muts.forEach((m) =>
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches?.("[data-money-amount]")) annotate(n, rate);
          n.querySelectorAll?.("[data-money-amount]").forEach((p) =>
            annotate(p, rate),
          );
        }),
      );
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
